export enum VideoLabelIcon {
    Video = "fa-solid fa-duotone fa-video",
    Alarm = "fa-solid fa-duotone fa-bell-ring",
    Driver = "fa-solid fa-duotone fa-user",
    DriverAbsent = "fa-solid fa-duotone fa-user-slash",
    Turning = "fa-solid fa-duotone fa-car-tilt",
    Car = "fa-solid fa-duotone fa-car",
    Acceleration = "fa-solid fa-duotone fa-car-on",
    Shock = "fa-duotone fa-solid fa-car-burst",
    CameraCovered = "fa-solid fa-duotone fa-video-slash",
}
